
import { defineComponent } from 'vue'
import PaperModalContent from './PaperModalContent.vue'
import AuthorModalContent from './AuthorModalContent.vue'

import {
  AuthorModalOptions,
  isAuthorModalOptions,
  isPaperModalOptons,
  ModalOptions,
  PaperModalOptions
} from '@/types/modalTypes'
import { EmitEvents } from '@/utils/emitHelpers'

export default defineComponent({
  name: 'Modal',
  components: {
    PaperModalContent,
    AuthorModalContent
  },
  data() {
    return {
      options: undefined as ModalOptions | undefined
    }
  },
  mounted() {
    this.emitter.on(EmitEvents.ShowModal, (options: ModalOptions) => {
      if (this.options !== undefined) {
        options.previousScreen = this.options
      }
      this.options = options
    })
  },
  computed: {
    isPaper(): boolean {
      return this.options !== undefined && isPaperModalOptons(this.options)
    },
    isAuthor(): boolean {
      return this.options !== undefined && isAuthorModalOptions(this.options)
    },

    validState(): boolean {
      return this.isPaper || this.isAuthor
    }
  },
  methods: {
    clearModal(): void {
      this.options = undefined
    },
    back(): void {
      if (this.options && this.options.previousScreen) {
        this.options = this.options.previousScreen
      } else {
        this.clearModal()
      }
    }
  }
})
